import {useMemo} from "react";
import {observer} from "mobx-react-lite";
import styled from "styled-components";

import { MaruModal } from "hooks/useModal";
import useStores from "hooks/useStores";
import { useToast } from "hooks/useToast";
import {useErrorHandler} from "hooks/useErrorHandler";

import { toastMessage } from "messages";

import ModalAddon from "components/ModalAddon";


const CompleteEachInspectionModal = observer(() => {
  const {
    similarQuestionList,
    unitSelect,
    questionList,
    activeUnit,
    activeQuestion
  } = useStores();
  const modalId = "completeEachInspectionModal";
  const toast = useToast();
  const handler = useErrorHandler();

  //* Event methods
  const handleOkayClick = async () => {
    if (mode === 3) return;
    if (!unitSelect.selected && !unitSelect.page) return;
    const page = typeof unitSelect.page === "number" ? [unitSelect.page] : unitSelect.page
    if (
      await handler.handle(
        questionList.updateMany(
          {
            question_ids: similarQuestionList.questionStorage.map(q => q._id),
            values: {
              unitCode: unitSelect.selected!.unitCode,
              page: page,
              inspection_status: "inspected",
              question_id: unitSelect.question_id
            }
          }
        )
      )
    ) return;
    toast.fireToast({
      type: "success",
      content: toastMessage.success.saveInspection,
      duration: 5000,
    });
    await activeUnit.setUnitCode(unitSelect.selected!.unitCode)
    await unitSelect.clear();
    await similarQuestionList.clear();
    await activeQuestion.clear();
    await activeUnit.clear();
  };

  const mode = useMemo(() => {
    if (similarQuestionList.questionStorage.every(u => u.inspection_status === "waiting" || u.inspection_status === "none"))
      return 1
    else return 3
    // eslint-disable-next-line
  }, [similarQuestionList.questionStorage.length])

  return (
    <MaruModal
      id={modalId}
      title="검수완료"
      withCancel={mode !== 3}
      onOkayClick={handleOkayClick}
    >
      <ModalInnerPanel>
        {mode === 1 && <OnlyUnchecked count={similarQuestionList.questionStorage.length}/>}
        {mode === 3 && <OnlyChecked />}
      </ModalInnerPanel>

      <ModalAddon mode="success" />
    </MaruModal>
  );
});

interface CompleteInspectionProps {
  count: number;
}

const OnlyUnchecked = ({count}: CompleteInspectionProps) => (
  <Paragraph>
    선택한 <b>{count}개 문항</b>을 <em>검수완료</em> 처리합니다.
  </Paragraph>
);
const OnlyChecked = () => (
  <Paragraph>
    이미 <em>검수완료</em> 처리된 문항입니다.
  </Paragraph>
);

const ModalInnerPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 16px;
  padding: 24px;

  border-radius: 4px;
  background: ${(props) => props.theme.background.DIM};
`;

const Paragraph = styled.p`
  font-size: 13px;
  color: #666666;
  text-align: center;
  line-height: 1.5rem;

  > b {
    font-weight: 500;
    color: ${(props) => props.theme.text.BLACK};
  }

  > em {
    color: ${(props) => props.theme.text.SUCCESS};
  }
`;

export default CompleteEachInspectionModal;
